export type MediaCategoryKey = 'TRAININGS' | 'EXERCISES' | 'WORKOUTS' | 'EDUCATION';

export interface IMediaCategoryOption {
  key: MediaCategoryKey;
  label: string;
  route: string;
  icon?: string;
}

export const DEFAULT_MEDIA_CATEGORY: MediaCategoryKey = 'TRAININGS';

export const MEDIA_CATEGORIES: IMediaCategoryOption[] = [
  { key: 'TRAININGS', label: 'Тренинги', route: 'skills' },
  { key: 'EXERCISES', label: 'Упражнения', route: 'exercises' },
  { key: 'WORKOUTS', label: 'Тренировки', route: 'workouts' },
  { key: 'EDUCATION', label: 'Образование', route: 'education' },
];

export function normalizeMediaCategory(value?: string | null): MediaCategoryKey {
  const key = (value || DEFAULT_MEDIA_CATEGORY).toUpperCase();
  return MEDIA_CATEGORIES.some((category) => category.key === key) ? (key as MediaCategoryKey) : DEFAULT_MEDIA_CATEGORY;
}

export function mediaCategoryLabel(value?: string | null): string {
  const key = normalizeMediaCategory(value);
  return MEDIA_CATEGORIES.find((category) => category.key === key)?.label || 'Тренинги';
}
